import { Divider, Grid, Typography } from "@mui/material"
import { ReactNode } from "react"
import { theme } from "../../../../../../styles"

export const HeaderFiltro = (props: {
  titulo: string
  descricao: ReactNode
}) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" color="primary" fontWeight="bold" textTransform="uppercase">
            {props.titulo}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider color={theme.palette.primary.main} />
        </Grid>
        <Grid item xs={12}>
          {props.descricao}
        </Grid>
      </Grid>
      <Divider color={theme.palette.primary.main} sx={{ my: 3 }} />
    </>
  )
}